export const GROUP_STATUS = {
  NOT_STARTED: 'Sin iniciar',
  IN_PROGRESS: 'En proceso',
  FINISHED: 'Finalizado',
  CANCELLED: 'CANCELADO'
};

function normalizeText(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

function hasValue(value) {
  return String(value ?? '').trim().length > 0;
}

function getStoredGroupStatus(group) {
  return String(
    group?.status ?? group?.groupStatus ?? group?.group_status ?? ''
  ).trim();
}

export function isGroupCancelled(group) {
  return normalizeText(getStoredGroupStatus(group)) === 'cancelado';
}

export function isGroupFinished(group) {
  return normalizeText(getStoredGroupStatus(group)) === 'finalizado';
}

function getMeetingDate(meeting) {
  return meeting?.meetingDate ?? meeting?.meeting_date ?? '';
}

function getMeetingOrder(meeting) {
  const order = Number(meeting?.order);
  return Number.isInteger(order) && order > 0 ? order : null;
}

function getProcessMeetingGroups(group) {
  const meetingGroups = group?.meetingGroups ?? group?.meeting_groups ?? [];
  if (!Array.isArray(meetingGroups)) return [];

  return meetingGroups
    .filter(meeting => String(meeting?.type || '').trim().toUpperCase() === 'MEETING')
    .sort((left, right) => (getMeetingOrder(left) || 0) - (getMeetingOrder(right) || 0));
}

function hasSessionProgress(meeting) {
  return hasValue(getMeetingDate(meeting)) || hasValue(meeting?.goal);
}

export function resolveGroupStatus(group, fallback = '-') {
  const fallbackStatus = typeof fallback === 'object' ? '-' : fallback;

  if (isGroupCancelled(group)) {
    return GROUP_STATUS.CANCELLED;
  }

  if (isGroupFinished(group)) {
    return GROUP_STATUS.FINISHED;
  }

  if (!group) {
    return fallbackStatus;
  }

  const meetingGroups = getProcessMeetingGroups(group);

  if (meetingGroups.some(hasSessionProgress)) {
    return GROUP_STATUS.IN_PROGRESS;
  }

  return GROUP_STATUS.NOT_STARTED;
}

export function buildGroupStatusClassName(status) {
  if (!status || status === '-') return 'empty';

  return normalizeText(status)
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}
